<template>
  <div class="news-bulletin-details-box" :style="{ height: height + 'px' }">
    <!--消息内容-->
    <div class="content" v-if="info">
      <div class="title">
        <div class="headline">{{ info.title }}</div>
        <!--        <div class="headline">我的天那哎我的天那哎我的天那哎我的天那哎我</div>-->
        <div class="msg">
          <div class="place"></div>
          <div class="date">{{ info.date }}</div>
        </div>
      </div>
      <div class="news-text" v-html="info.content"></div>
      <div class="remarked">阅读&nbsp;{{ info.remarked }}</div>
      <!-- v-if="isSign" -->
      <s-h-button
        v-if="info.type === 1"
        class="btn"
        @click="signIn"
        :type="`${isSign ? 'confirmed' : 'primary'}`"
        style="margin: 0 auto;"
        >{{ isSign ? '已' : '' }}签收</s-h-button
      >
    </div>
    <!--异常情况-->
    <div class="unusual-box flex-col" v-if="unusual.isShow">
      <img
        :src="require('../../assets/img/common/noSearch.png')"
        alt=""
        class="img"
      />
      <span>{{ unusual.message }}</span>
    </div>
  </div>
</template>

<script>
import { bulletinApi } from '@/api';

export default {
  name: 'Bulletin',

  mixins: [],

  components: { SHButton: () => import('@/components/ShButton') },

  props: {},

  data() {
    return {
      id: '',
      info: null,
      isSign: false,
      signLoad: false,
      isUnusual: false,
      unusual: {
        isShow: false,
        message: '',
      },
      height: 0,
    };
  },

  computed: {
    /**
     * 获取详情参数
     * @param vm
     * @returns {{eventId: string | (string | null)[], noticeType: string | (string | null)[], id: string | (string | null)[], storeId: number, type: string | (string | null)[]}}
     */
    detailParams(vm) {
      return {
        eventId: vm.$route.query.eventId,
        id: vm.$route.query.page === 'home' ? '' : vm.$route.query.id,
        noticeType: vm.$route.query.noticeType,
        storeId: vm.$store.state.account.storeId,
        type: '9',
      };
    },
    /**
     * 签收参数
     * @param vm
     * @returns {{id, storeId: (number|string|*)}}
     */
    signParams(vm) {
      return {
        id: vm.detailParams.eventId,
        storeId: vm.detailParams.storeId,
      };
    },
  },

  watch: {},

  created() {
    this.initData();
  },

  mounted() {
    const resizeObserver = new ResizeObserver(() => {
      setTimeout(() => {
        this.height =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
      }, 1000);
    });
    resizeObserver.observe(document.querySelector('html'));
  },

  destroyed() {},

  methods: {
    async initData() {
      const [err, res] = await this.$bsUtils.request(
        bulletinApi.detail(this.detailParams)
      );

      if (err) {
        if (err.status === 5001) {
          return (this.unusual = {
            isShow: true,
            message: '该公告已下架',
          });
        }

        return this.$bsUtils.toast(err.message || '获取公告内容失败！');
      }

      this.info = this.dealWithInfo(res);
      this.isSign = !!res.isSign;
    },
    /**
     * 处理详情信息
     * @returns {{date: string, remarked: string, title: string, content: string}}
     */
    dealWithInfo(res) {
      return {
        title: res.title,
        date: res.createTime,
        content: res.content,
        remarked: res.views,
        type: res.type,
      };
    },
    async signIn() {
      if (this.isSign) return false;

      this.signLoad = true;
      const [err] = await this.$bsUtils.request(
        bulletinApi.sign(this.signParams)
      );
      if (err) {
        return this.$bsUtils.toast(err.message || '公告签收失败！');
      }

      this.$bsUtils.toast('签收成功');
      this.isSign = true;
      this.signLoad = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/less/editor.css';

.news-bulletin-details-box {
  width: 100%;
}
.content {
  width: 100%;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 19px 24px 24px;
  align-items: center;
  .title {
    width: 100%;
    .headline {
      width: 100%;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      color: #333333;
      padding: 0;
      margin: 0;
    }
    .msg {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
  .news-text {
    text-align: left;
  }
  .remarked {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    text-align: left;
  }
}
.log {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 64px;
  background: #ffffff;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 10px;
  & > div {
    position: relative;
    flex: 1;
    padding: 10px 0 0 14px;
    .num {
      font-size: 15px;
      font-weight: 500;
      color: #416bed;
      line-height: 30px;
    }
    .label {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
    }
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 20px;
      background: #e4e4e4;
    }
    &:last-of-type::after {
      display: none;
    }
  }
  .btn {
    margin: 0 auto;
  }
}

.unusual-box {
  align-items: center;
  .img {
    margin-top: 62px;
    margin-bottom: 25px;
    width: 250px;
  }
  span {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
  }
}
</style>
